import useData from "./useData";
import { useMemo } from "react";

export interface Customer {
    id: string | number,
    customerno: string,
    customername: string,
    producturl?: string,
    checkoutinfo?: string,
    webshoplogininfo?: string

}

const useCustomer = (pageOffset?: number, pageSize?: number) => {
    const {
        data,
        ...others
    } = useData<Customer>('/1.0/customers', {
        pageOffset,
        pageSize
    });

    const customers = useMemo(() => data.map((row: any) => ({
        id: row.customerno,
        ...row,
    })), [data]);

    return {
        customers,
        ...others
    }
}

export default useCustomer;